






















import Vue from 'vue';
import adBanner from '@/components/common/banner/adBanner.vue';
export default Vue.extend({
    props: ['data'],
    components: {
        adBanner
    },
    data() {
        return {
            adPage: 'purchase',
            adType: this.$route.params.type === 'fund' ? 'announceInsideBanner' : 'announceBanner'
        };
    },
    watch: {
        data: function(val) {
            if (val.title) {
                let type = this.$route.params.type === 'fund' ? '基金公告' : '基富通公告';
                let url = this.$route.params.type === 'fund' ? '/announce.html?page=fund' : '/announce.html?page=frs';
                let params: any = [
                    {
                        name: type,
                        link: url
                    }
                ];
                this.$store.commit('setBreadCrumbs', params);
            }
        }
    },
    methods: {
        GAcode(el: string) {
            if (typeof window.ActionAnalysisV2 !== 'undefined' && typeof el !== 'undefined') {
                window.ActionAnalysisV2.actClk(el);
            }
        }
    }
});
